module.exports = __webpack_public_path__ + "media/assets/icons/pencil-59d58488c6803fdeacfe49edebbf7eae.svg";